import { render } from "./SpoofIndex.vue?vue&type=template&id=3efd0f70"
import script from "./SpoofIndex.vue?vue&type=script&lang=js"
export * from "./SpoofIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__